import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, DatePicker } from "antd";
import styled from "styled-components";
import * as R from "ramda";
import moment from "moment";

import * as gtag from "../../../../../lib/gtag";

import { Container, Title } from "./FilterComponents";

const { RangePicker } = DatePicker;

const displayDateFormat = "DD/MM/YY";
const backendDateFormat = "YYYY-MM-DD";

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  .div {
    margin: 0 15px;
  }
  .clear {
    margin-left: 12px;
    min-width: 32px;
    height: 32px;
  }
  .ant-calendar-picker-input.ant-input {
    padding-right: 20px;
  }
`;

const toString = value => value.map(d => d.format(backendDateFormat));
const fromString = value => value.map(d => moment(d, backendDateFormat));

const DateFilter = ({ title, loading, onChange, value = [] }) => {
  const { t } = useTranslation();
  const [internalValue, setInternalValue] = useState(fromString(value));

  const disabledDate = useCallback(date => date && date.isAfter(), []);

  const handleChange = useCallback(newValue => {
    // console.log("handleChange", newValue);
    setInternalValue(newValue);
  }, []);

  const handleSubmit = useCallback(() => {
    gtag.event({
      category: "VacancyCandidates",
      action: `filterApplyDate`
    });
    onChange(toString(internalValue));
  }, [internalValue, onChange]);

  const canSubmit = useMemo(() => !R.equals(toString(internalValue), value), [
    internalValue,
    value
  ]);

  const defaultRanges = useMemo(
    () => ({
      [t("opportunity:candidates.applyDateFilters.today")]: [
        moment(),
        moment()
      ],
      [t("opportunity:candidates.applyDateFilters.thisWeek")]: [
        moment().startOf("week"),
        moment()
      ],
      [t("opportunity:candidates.applyDateFilters.thisMonth")]: [
        moment().startOf("month"),
        moment()
      ],
      [t("opportunity:candidates.applyDateFilters.last30Days")]: [
        moment().subtract(30, "days"),
        moment()
      ],
      [t("opportunity:candidates.applyDateFilters.last90Days")]: [
        moment().subtract(90, "days"),
        moment()
      ],
      [t("opportunity:candidates.applyDateFilters.thisYear")]: [
        moment().startOf("year"),
        moment()
      ]
    }),
    [t]
  );

  // console.log("value", value);
  // console.log("internalValue", internalValue);

  return (
    <details open={value && !R.isEmpty(value)}>
      <Title>
        <h4>{title}</h4>
      </Title>
      <Container>
        <Row>
          <RangePicker
            placeholder={["Start", "End"]}
            format={displayDateFormat}
            value={internalValue}
            disabled={loading}
            disabledDate={disabledDate}
            onChange={handleChange}
            ranges={defaultRanges}
          />
          <Button
            className="clear"
            shape="circle"
            icon="arrow-right"
            type="primary"
            disabled={!canSubmit}
            onClick={handleSubmit}
          />
        </Row>
      </Container>
    </details>
  );
};

export default DateFilter;
